import React, { useState, useEffect } from "react";
import videofondo from "../videos/testimonios.mp4";

import Tesista1 from "../Images/Tesista1.png";
import Tesista3 from "../Images/Tesista3.png";
import Tesista4 from "../Images/Tesista4.jpg";
import Tesista5 from "../Images/foto_portada5.png";
import Tesista6 from "../Images/Tesista6.png";
import Tesista7 from "../Images/Tesista7.png";
import Nilmer from "../Images/Nilmer.png";
import juan from "../Images/juan.jpg";
import Xavier from "../Images/Xavier.png";

import "../Css/testimonios.css";
import { FaQuoteLeft, FaQuoteRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import logoWhatsapp from "../Images/logo-whatsapp1.png";
import Footer from "../Components/footer";

const testimoniosData = [
    {
        id: 3,
        nombre: "Yuliana Reyes",
        grado: "Maestría en docencia universitaria",
        universidad: "Universidad César Vallejo-UCV",
        testimonio: "Valoro el compromiso de Investí con la calidad. Me guiaron durante todo el proceso y fortalecí habilidades de investigación que hoy aplico en mi profesión.",
        imagen: Tesista4
    },
    {
        id: 1,
        nombre: "Guisseppe Reyes",
        grado: "Título Universitario",
        universidad: "Universidad Católica Benedicto XVI, Trujillo",
        testimonio: "Gracias a Investí pude completar mi tesis en tiempo récord. Su metodología y asesoramiento personalizado fueron clave para mi éxito académico.",
        imagen: Tesista1
    },
    {
        id: 2,
        nombre: "María Sánchez",
        grado: "Master in Business Administration (MBA)",
        universidad: "UNIR - Master in  Business Administration (MBA) - España",
        testimonio: "El apoyo de Investí fue fundamental para estructurar correctamente mi investigación. Los asesores tienen un dominio excepcional de las metodologías y están disponibles cuando los necesitas.",
        imagen: Tesista3
    },
    {
        id: 8,
        nombre: "Nilmer Quispe ",
        grado: "Maestría en Ingeniería de  Minas",
        universidad: "Univerdad Nacional Mayor de San Marcos-UNMSM",
        testimonio: "Gracias a Investí, conté con asesoría y acompañamiento confiable. Su experiencia hizo que mi tesis avanzara con claridad y orden.",
        imagen: Nilmer
    },
    {
        id: 9,
        nombre: "Juan Carlos ",
        grado: "Maestría en Administración de  Negocios (MBA)",
        universidad: "Universidad César Vallejo-UCV",
        testimonio: "Investí me brindó asesoría y confianza en cada etapa. Su experiencia y compromiso hicieron que todo el proceso fuera claro y exitoso..",
        imagen: juan
    },

    {
        id: 10,
        nombre: "Karlo Xavier Bejar Roque ",
        grado: "Maestro en Gestión Pública",
        universidad: "Universidad César Vallejo-UCV",
        testimonio: "Gracias a Investí, me sentí acompañado en cada paso del proceso. Su profesionalismo y dedicación me dieron la tranquilidad que necesitaba para tomar decisiones con seguridad. Sin duda, superaron mis expectativas.",
        imagen: Xavier
    },

];

const graduadosDestacados = [
    {
        id: 1,
        nombre: "Guisseppe Alonso Reyes García",
        titulo: "Título Universitario",
        año: "2024",
        imagen: Tesista1,
        universidad: "Universidad Católica Benedicto XVI, Trujillo"
    },
    {
        id: 2,
        nombre: "María Graciela Sánchez Arce",
        titulo: "Master in Business Administration (MBA)",
        año: "2024",
        imagen: Tesista3,
        universidad: "UNIR - Master in  Business Administration (MBA) - España"
    },
    {
        id: 5,
        nombre: "Donalson Camacho Sinti",
        titulo: "Título Universitario",
        año: "2024",
        universidad: "Universidad Católica de Trujillo-UCT",
        imagen: Tesista6
    },
    {
        id: 3,
        nombre: "Yuliana Reyes",
        titulo: "Maestría en docencia universitaria",
        año: "2024",
        imagen: Tesista4,
        universidad: "Universidad César Vallejo-UCV"
    },
    {
        id: 6,
        nombre: "Felixmer Davalos",
        titulo: "Maestría en docencia universitaria",
        año: "2024",
        universidad: "Universidad César Vallejo-UCV",
        imagen: Tesista7
    },
    {
        id: 8,
        nombre: "Nilmer Quispe Chavarri",
        titulo: "Maestría en Ingeniería de Minas",
        año: "2024",
        imagen: Nilmer,
        universidad: "Univerdad Nacional Mayor de San Marcos-UNMSM"
    },
    {
        id: 9,
        nombre: "Juan Carlos Parra Paucar",
        titulo: "Maestría en Administración de Negocios (MBA)",
        año: "2024",
        imagen: juan,
        universidad: "Universidad César Vallejo-UCV"
    },


    {
        id: 10,
        nombre: "Karlo Xavier Bejar Roque",
        titulo: "Maestro en Gestión Pública",
        año: "2025",
        imagen: Xavier,
        universidad: "Universidad César Vallejo-UCV"
    },
];

const Testimonios = () => {
    const [activeTestimonio, setActiveTestimonio] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    const cambiarTestimonio = (direccion) => {
        if (isAnimating) return;

        setIsAnimating(true);

        setActiveTestimonio((prev) => {
            if (direccion === 'siguiente') {
                return prev === testimoniosData.length - 1 ? 0 : prev + 1;
            } else {
                return prev === 0 ? testimoniosData.length - 1 : prev - 1;
            }
        });

        setTimeout(() => {
            setIsAnimating(false);
        }, 500);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            cambiarTestimonio('siguiente');
        }, 8000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="testimonios-container">
            <div className="panel-video">
                <div className="overlay">
                    <div className="video-container">
                        <video className="video-custom" autoPlay loop muted>
                            <source src={videofondo} type="video/mp4" />
                            Tu navegador no soporta videos.
                        </video>
                    </div>
                    <div className="texto-section">
                        <h2>TESTIMONIOS DE ÉXITO</h2>
                        <p>Observa sus testimonios y descubre cómo Investí puede ayudarte a alcanzar tu meta académica</p>
                    </div>
                </div>
            </div>

            <div className="testimonios-carrusel-container">
                <h2 className="testimonios-titulo" style={{ fontSize: "2.0em", fontWeight: "normal" }}>
                    LO QUE NUESTROS CLIENTES DICEN SOBRE NOSOTROS
                </h2>


                <div className="testimonios-carrusel">
                    <button
                        className="carrusel-btn carrusel-btn-prev"
                        onClick={() => cambiarTestimonio('anterior')}
                        aria-label="Testimonio anterior"
                    >
                        <FaChevronLeft />
                    </button>

                    <div className={`testimonios-slide ${isAnimating ? 'animating' : ''}`}>
                        <div className="testimonio-card">
                            <div className="testimonio-imagen-container">
                                <img
                                    src={testimoniosData[activeTestimonio].imagen}
                                    alt={testimoniosData[activeTestimonio].nombre}
                                    className="testimonio-imagen"
                                />
                            </div>
                            <div className="testimonio-contenido">
                                <FaQuoteLeft className="testimonio-quote testimonio-quote-left" />
                                <p className="testimonio-texto">
                                    {testimoniosData[activeTestimonio].testimonio}
                                </p>
                                <FaQuoteRight className="testimonio-quote testimonio-quote-right" />
                                <div className="testimonio-autor">
                                    <h4>{testimoniosData[activeTestimonio].nombre}</h4>
                                    <p>{testimoniosData[activeTestimonio].grado}</p>
                                    <span>{testimoniosData[activeTestimonio].universidad}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        className="carrusel-btn carrusel-btn-next"
                        onClick={() => cambiarTestimonio('siguiente')}
                        aria-label="Testimonio siguiente"
                    >
                        <FaChevronRight />
                    </button>
                </div>

                <div className="testimonios-indicadores">
                    {testimoniosData.map((_, index) => (
                        <span
                            key={index}
                            className={`indicador ${index === activeTestimonio ? 'indicador-activo' : ''}`}
                            onClick={() => setActiveTestimonio(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="graduados-container">
                <div className="graduados-header">
                    <h2 style={{ fontSize: "2.0em", fontWeight: "normal" }}>NUESTROS GRADUADOS DESTACADOS </h2>
                    <p style={{ fontSize: "1.5em", fontWeight: "normal" }}>Conoce a quienes lograron su título con nuestro apoyo</p>

                </div>

                <div className="graduados-grid">
                    {graduadosDestacados.map((graduado) => (
                        <div className="graduado-card" key={graduado.id}>
                            <div className="graduado-imagen-container">
                                <img
                                    src={graduado.imagen}
                                    alt={graduado.nombre}
                                    className="graduado-imagen"
                                />
                                <div className="graduado-overlay">
                                    <span className="graduado-año">{graduado.año}</span>
                                </div>
                            </div>
                            <div className="graduado-info">
                                <h4>{graduado.nombre}</h4>
                                <p>{graduado.titulo}</p>
                                <span>{graduado.universidad}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <a
                href="https://wa.me/51961867761"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-circle whatsapp-btn-inicio"
            >
                <img
                    src={logoWhatsapp}
                    alt="WhatsApp"
                    className="whatsapp-icon-inicio"
                />
            </a>
            <Footer />
        </div>
    );
};

export default Testimonios;
